<app-content-box>
    <div class="monitored-cases-container">
        <button mat-button class="add-exam" (click)="showAdder()">{{ labels.ADD_EXAMS }}</button>
        <div class="exam-adder" *ngIf="showingExamAdder">
            <div class="close-ctl" (click)="hideAdder()">
                <i class="fas fa-xmark"></i>
            </div>
            <div class="exam-param">
                <p>{{ labels.CODE }}</p>
                <input type="text" [(ngModel)]="currentNewCode" class="form-border"
                (keydown.enter)="saveNewExam()">
            </div>
            <button mat-button (click)="saveNewExam()">{{ labels.ADD }}</button>
        </div>
        <div class="search-exam">
            <i class="fas fa-magnifying-glass search"></i>
            <input type="text" class="form-border" [(ngModel)]="filterText" (input)="filterList()"/>
        </div>
        <div class="exams-monitored" *ngIf="caseList && caseList.length > 0; else emptyCase">
            <table
            mat-table
            [dataSource]="dataSource"
            >
    
            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>
                  {{ labels.CODE }}
                </th>
                <td mat-cell *matCellDef="let exam">
                  {{ exam.code }}
                </td>
            </ng-container>

            <ng-container matColumnDef="open">
                <th mat-header-cell *matHeaderCellDef>
                  {{ labels.OPEN }}
                </th>
                <td mat-cell *matCellDef="let exam">
                  <i class="fas fa-up-right-from-square" (click)="openExam(exam.code)"></i>
                </td>
            </ng-container>

            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef>
                {{ labels.DELETE }}
              </th>
              <td mat-cell *matCellDef="let exam">
                <i class="fas fa-trash delete-btn" (click)="deleteExam(exam.id)"></i>
              </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
                mat-row
                *matRowDef="let exam; columns: displayedColumns"
                tabindex="0"
            ></tr>
    
            </table>

            <span class="paginator-container" *ngIf="pageSize < count">
                <mat-paginator
                  #paginator
                  class="paginator"
                  (page)="handlePageEvent($event)"
                  [length]="count"
                  [pageSize]="pageSize"
                  [showFirstLastButtons]="showFirstLastButtons"
                  [pageSizeOptions]="[]"
                  [hidePageSize]="hidePageSize"
                  [pageIndex]="pageIndex"
                  aria-label="labels_paginators.PAGINATOR"
                >
                </mat-paginator>
            </span>
        </div>
    </div>

    <ng-template #emptyCase>
        <div class="spinner-container" *ngIf="loading">
          <mat-spinner></mat-spinner>
        </div>
        <div *ngIf="!loading">
          {{ labels.NOCASE }}
        </div>
    </ng-template>
</app-content-box>
